import React, { useEffect, useState } from 'react';
import Text from '../../../../../Components/Base/Text/Text';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
import LinkButton from '../../../../../Components/Button/LinkButton';
import useTranslation from '../../../../../Hooks/useTranslation';
import { useEffectAsync } from '../../../../../helpers';
import apiClient from '../../../../../Services/ApiClient';
import { useAppContext } from '../../../../../Services/AppContext';

// @ts-ignore
import styles from './NCZIWizardSteps.module.scss';
import useNCZIConnectionCheck from '../../../Hooks/useNCZIConnectionCheck';

interface Props {
	onContinue: () => void;
}

const NCIWizardSetupInstructions: React.FC<Props> = ({ onContinue }) => {
	const { t } = useTranslation();
	const { isCardConnectLogged } = useNCZIConnectionCheck();

	return (
		<div className={styles.wrapper}>
			<Text tx='nczi.wizardSetupInstructions.title' className={styles.title} />
			<ol>
				<li>
					{t('nczi.wizardSetupInstructions.list.item1')}{' '}
					<LinkButton
						title='nczi.here'
						theme={Theme.BLUE}
						href='https://cdn.meddi.com/distribution/md/card-connect/setup.exe'
					/>{' '}
				</li>
				<li>{t('nczi.wizardSetupInstructions.list.item2')}</li>
				<li>{t('nczi.wizardSetupInstructions.list.item3')}</li>
			</ol>
			<Button
				theme={isCardConnectLogged ? Theme.GREEN : Theme.DISABLED}
				onClick={onContinue}
				title={isCardConnectLogged ? 'base.shared.continue' : 'nczi.wizardSetupInstructions.buttonWaiting'}
				className={styles.button}
				disabled={!isCardConnectLogged}
			/>
		</div>
	);
};

export default NCIWizardSetupInstructions;
